module.exports = __webpack_public_path__ + "img/Weapon_245.f11cf86d.png";